<div class="layout-col full p-sm scroll-fix">
  <div class="layout-col scrollable">
    <mat-tree
      [dataSource]="dataSource"
      [treeControl]="treeControl"
      class="example-tree"
      style="height: 100%"
    >
      <!-- This is the tree node template for leaf nodes -->
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
        <li class="mat-tree-node">
          <!-- use a disabled button to provide padding for tree leaf -->
          <button disabled mat-icon-button>
            <mat-icon style="font-size: 10px">trip_origin</mat-icon>
          </button>
          <ng-container
            *ngTemplateOutlet="itemTemplate; context: { $implicit: node }"
          ></ng-container>
        </li>
      </mat-tree-node>
      <!-- This is the tree node template for expandable nodes -->
      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
        <li>
          <div class="mat-tree-node">
            <button [attr.aria-label]="'toggle ' + node.name" mat-icon-button matTreeNodeToggle>
              <mat-icon class="mat-icon-rtl-mirror">
                {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
              </mat-icon>
            </button>
            <ng-container
              *ngTemplateOutlet="itemTemplate; context: { $implicit: node }"
            ></ng-container>
          </div>
          <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
            <ng-container matTreeNodeOutlet></ng-container>
          </ul>
        </li>
      </mat-nested-tree-node>
    </mat-tree>
  </div>

  <ng-template #itemTemplate let-namedComponent>
    @if (namedComponent.component; as component) {
      <div (click)="openDetail(namedComponent)" class="bom-item layout-col">
        <div class="layout-row place-start-center gap-sm">
          <mat-icon>{{ getIcon(component) }}</mat-icon>
          <span class="item-text name">{{ namedComponent.name }}</span>
          <span class="item-text material text-body-small"
            >{{ component.material?.materialId }}{{ component.config?.type
            }}{{ component.propertySet?.schema }}{{ component.document?.mimeType }}</span
          >
          <span class="item-text quantity">{{
            MaterialComponent.salesQuantity(component.material) | elderQuantity
          }}</span>
        </div>
        <div class="layout-row place-start-center gap-sm">
          <span style="width: 24px"></span>
          <span class="text-body-small">{{ component.description }}</span>
        </div>
      </div>
    }
  </ng-template>
</div>
